import { render, staticRenderFns } from "./NostoProduct.vue?vue&type=template&id=1ad5086e&"
import script from "./NostoProduct.vue?vue&type=script&lang=ts&"
export * from "./NostoProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports